module.exports = __webpack_public_path__ + "/img/QFP-Labeled-3QQdpv.svg";